import { useEffect, useRef, useState } from "react";
import { accountingCRUD } from "../../../actions/accounting";
import { Button, DateRangePicker, Pagination, SelectPicker } from "rsuite";
import { char, number } from "../../../utils";
import { invoiceCRUD } from "../../../actions/invoice";
import { reportCRUD } from "../../../actions/report";
import { DownloadTableExcel } from "react-export-table-to-excel";
import FilePdfOIcon from "@rsuite/icons/legacy/FilePdfO";
import FileExcelOIcon from "@rsuite/icons/legacy/FileExcelO";
import { useReactToPrint } from "react-to-print";
import moment from "moment";

const { afterToday } = DateRangePicker;

export const FullPaymentReportContent = () => {
  const dataRef = useRef();
  const tableRef = useRef();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [date, setDate] = useState([]);
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(1);
  const [nextPage, setNextPage] = useState(1);
  const [type, setType] = useState(null);
  const [indexSearch, setIndexSearch] = useState(0);

  const handleGeneratePdf = useReactToPrint({
    content: () => dataRef.current,
  });

  useEffect(() => {
     if(type) {
        setLoading(true);
        setTimeout(() => {
            reportCRUD
              .loadFullPaymentReport(type, nextPage, limit)
              .then((resp) => {
                setData(resp.data.results);
                setCount(resp.data.count);
              })
              .catch(() => {})
              .finally(() => {
                setLoading(false);
              });
        },500)
     }
  },[nextPage, limit, type]);

  

  const handleChangePage = (event) => {
    setData([]);

    setPage(event);
    setNextPage(event);
  };

  const handleChange = (selectedOption) => {
    setData([]);
    setLimit(selectedOption);
    setNextPage(1);
    setPage(1);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2" style={{ marginTop: -30 }}>
          <div className="col-12">
            {type ? (
              <p className="h6 fs-18 fw-bold text-dark">
                {char.toTitleCase(type)}'s Full Paid Report
              </p>
            ) : (
              <p className="h6 fs-18 fw-bold text-dark">FullPayment Report</p>
            )}
          </div>
          <hr className="mt-3" />
        </div>
        <div className="row">
          <div className="col-12 card">
            <div
              className="card-body"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <div className="row">
                <div className="col-md-3 col-sm-12">
                  <SelectPicker
                    className="w-100"
                    cleanable={true}
                    data={[
                      { value: "admission", label: "Admissions" },
                      { value: "customer", label: "Customers" },
                      { value: "student", label: "Students" },
                    ]}
                    onChange={(e) => {
                      setType(e);
                    }}
                    placeholder="Select Customer"
                    onClean={() => {
                      setType(null);
                    }}
                  />
                </div>
                <div className="col-md-5 col-sm-12" />
                {data.length ? (
                  <>
                    <div className="col-md-2 col-sm-6">
                      <Button
                        color="green"
                        appearance="primary"
                        startIcon={<FileExcelOIcon />}
                        block={true}
                        disabled={!data}
                      >
                        <DownloadTableExcel
                          filename="Report"
                          sheet="sheet1"
                          currentTableRef={tableRef.current}
                        >
                          Download Excel
                        </DownloadTableExcel>
                      </Button>
                    </div>
                    <div className="col-md-2 col-sm-6">
                      <Button
                        color="red"
                        appearance="primary"
                        startIcon={<FilePdfOIcon />}
                        block={true}
                        onClick={handleGeneratePdf}
                        disabled={!data}
                      >
                        Download PDF
                      </Button>
                    </div>
                  </>
                ) : null}
                {/* <div className="col-md-3 col-sm-12">
                  <DateRangePicker
                    cleanable
                    placement="bottomEnd"
                    onClean={() => setDate([])}
                    onShortcutClick={(e) => {
                      setDate([
                        moment(e.value[0]).format("YYYY-MM-DD"),
                        moment(e.value[1]).add(1, "days").format("YYYY-MM-DD"),
                      ]);
                    }}
                    onOk={(e) =>
                      setDate([
                        moment(e[0]).format("YYYY-MM-DD"),
                        moment(e[1]).add(1, "days").format("YYYY-MM-DD"),
                      ])
                    }
                    shouldDisableDate={afterToday()}
                    placeholder="Select date range"
                    className="w-100"
                  />
                </div>
                <div className="col-md-2 col-sm-12">
                  <button
                    className="btn btn-primary"
                    onClick={() => setIndexSearch(indexSearch + 1)}
                  >
                    <i className="ri-search-line me-2"></i>
                    Search
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 card">
            <div className="card-body">
              <div ref={dataRef}>
                <div class="table-responsive" ref={tableRef}>
                  <div className="printHead">
                    <p className="text-center">
                      <img
                        width={100}
                        className="mt-0 mb-2"
                        src="assets/images/suza.jpeg"
                        alt=""
                      />
                    </p>
                    <p className="text-center fw-bold head1">
                      {char.toTitleCase("state university of Zanzibar")}
                    </p>
                    <p className="text-center mt-3 mb-3 head2">
                      {char.toUpperCase(type+"'s Full Paid Report")}
                    </p>
                    {/* <p className="text-end">
                      Printed By :{" "}
                      <span className="fw-bold">
                        {char.toUpperCase(user.username)}
                      </span>
                    </p> */}
                    <p className="text-end mb-2">
                      Printed at :{" "}
                      <span className="fw-bold">
                        {moment().format("ddd DD MMM YYYY")}
                      </span>
                    </p>
                  </div>
                  <table className="table table-bordered table-striped">
                    <thead className="table-dark">
                      <tr>
                        <th className="text-start">#</th>
                        {type === "admission" ? (
                          <th className="text-start">Index No</th>
                        ) : type === "customer" ? (
                          <th className="text-start">TIN No</th>
                        ) : type === "student" ? (
                          <th className="text-start">Registration No</th>
                        ) : (
                          <th className="text-start">Identifier</th> // fallback
                        )}
                        <th className="text-start">Full Name</th>
                        <th className="text-end">Invoice</th>
                        <th className="text-end">Payment</th>
                        <th className="text-end">Balance</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td
                            colSpan={6}
                            className="text-center text-secondary py-3"
                          >
                            <div
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            />
                            Loading...
                          </td>
                        </tr>
                      ) : !type ? (
                        <tr>
                          <td
                            colSpan={6}
                            className="text-center text-muted py-3"
                          >
                            No data type chosen.
                          </td>
                        </tr>
                      ) : data.length === 0 ? (
                        <tr>
                          <td
                            colSpan={6}
                            className="text-center text-muted py-3"
                          >
                            No data available.
                          </td>
                        </tr>
                      ) : (
                        data.map((item, index) => (
                          <tr key={index}>
                            <td className="text-start">{index + 1}</td>
                            <td className="text-start">
                              {type === "admission"
                                ? char.toUpperCase(item.index_number)
                                : type === "customer"
                                ? char.toUpperCase(item.tin)
                                : char.toUpperCase(item.registration_number)}
                            </td>
                            <td className="text-start">
                              {char.toUpperCase(item.name)}
                            </td>
                            <td className="text-end">
                              {number.fNumberDoublePoint(item.invoice)}
                            </td>
                            <td className="text-end">
                              {number.fNumberDoublePoint(item.payment)}
                            </td>
                            <td className="text-end">
                              <span
                                className={
                                  item.balance > 0
                                    ? "text-danger"
                                    : item.balance < 0
                                    ? "text-success"
                                    : ""
                                }
                              >
                                {number.fNumberDoublePoint(
                                  Math.abs(parseFloat(item.balance))
                                )}
                              </span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-2 mt-3">
                  <span>Total rows : &nbsp; {count}</span>
                </div>
                <div className="col-10">
                  <div className="row g-2 mt-2 justify-content-start justify-content-md-end align-items-center">
                    <div className="col-auto paginate">
                      <Pagination
                        prev
                        last
                        next
                        first
                        ellipsis
                        boundaryLinks={true}
                        maxButtons={5}
                        size="sm"
                        limitOptions={[50, 100, 150, 250, 500, count]}
                        layout={["limit", "|", "pager", "|", "skip"]}
                        total={count}
                        limit={limit}
                        activePage={page}
                        onChangePage={handleChangePage}
                        onChangeLimit={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
